import React, { ChangeEventHandler } from "react";

interface Props {
  checkboxData: {
    id: string;
    label: string;
    callBack?: ChangeEventHandler<HTMLInputElement>;
  };
  checked: boolean;
}

const CustomCheckbox = ({ checkboxData, checked }: Props) => {
  const { label, id, callBack = () => {} } = checkboxData;

  return (
    <div className="custom_check-box">
      <input
        type="checkbox"
        id={id}
        className="custom_check-box_input"
        checked={checked}
        onChange={callBack}
      />
      <label
        htmlFor={id}
        className={
          checked ? "custom_check-box_label active" : "custom_check-box_label"
        }
      >
        {label}
      </label>
    </div>
  );
};

export default CustomCheckbox;
